const eventEnumerators = {
  eventStatus: [
    'draft',
    'online',
    'archived',
  ],
  eventVisibility: [
    'local',
    'regional',
    'global',
  ],
};

export default eventEnumerators;
